import { AgxLabel, AgxRow } from '@urbanx/agx-ui-components';
import clsx from 'clsx';
import type { Segment } from '@urbanx/agx-ui-components';
import './SegmentedPicker.scss';

interface SegmentedPickerProps {
  segments: Segment[];
  id: string;
}

const SegmentedPicker = ({ segments, id }: SegmentedPickerProps) => {
  return (
    <AgxRow extraClasses="segmentedPicker">
      {segments.map((segment, idx) => {
        const { title, mobileTitle, isSelected, onSelect } = segment;

        let mobileTitleText = mobileTitle ?? title;

        return (
          <SegmentComponent
            id={`${id}-${idx}`}
            key={idx}
            title={title}
            mobileTitle={mobileTitleText}
            isSelected={isSelected}
            onSelect={onSelect}
          />
        );
      })}
    </AgxRow>
  );
};

const SegmentComponent = ({
  title,
  mobileTitle,
  isSelected,
  onSelect,
  id,
}: Segment & { id: string }) => {
  const classes = clsx('segmentPicker', isSelected && 'selected');

  return (
    <div className={classes} onClick={onSelect}>
      <AgxLabel medium extraClasses={classes} dataTestId={id}>
        <span className="title" data-testid={`${id}-title`}>
          {title}
        </span>
        <span className="mobileTitle" data-testid={`${id}-mobile-title`}>
          {mobileTitle}
        </span>
      </AgxLabel>
    </div>
  );
};

export default SegmentedPicker;
